module.exports = __webpack_public_path__ + "f342cc7771429afa50fe8db91340622c.png";


//////////////////
// WEBPACK FOOTER
// ./components/home/brokerage/compliance.png
// module id = 662
// module chunks = 0